import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap, map } from 'rxjs';
import { endpoints } from '../../environments/endpoints';
import { LaravelDefaultResponse } from '../Interfaces/response.interface';
import { OnboardingConfigInterface } from '../Interfaces/config.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingConfigService {
  private readonly _api = inject(ApiService);

  private readonly _graphPermissions = signal<string[]>([]);
  private readonly _callbackUrl = signal<string>('');
  private readonly _configLoaded = signal<boolean>(false);

  readonly graphPermissions = this._graphPermissions.asReadonly();
  readonly callbackUrl = this._callbackUrl.asReadonly();
  readonly configLoaded = this._configLoaded.asReadonly();

  getOnboardingConfig(options: { skipLoading?: boolean } = {}): Observable<OnboardingConfigInterface> {
    return this._api
      .get<LaravelDefaultResponse<OnboardingConfigInterface>>(endpoints.onboarding.config, options)
      .pipe(
        map((response) => response.data),
        tap((config) => {
          this._graphPermissions.set(config.permissions);
          this._callbackUrl.set(config.callback_url);
          this._configLoaded.set(true);
        })
      );
  }
}
